// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","FilterLinks__link":"ca_a bha_h bha_ka bha_ux bha_ro bha_un bha_rq bha_rh"};